import React from 'react';
import PropTypes from 'prop-types';
import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import Logo from 'bento-ordering/base/components/Logo';
import GridContainer from 'bento-ordering/base/ui_components/GridContainer';

const AppBar = props => {
  return (
    <MuiAppBar color="inherit">
      <GridContainer>
        <Toolbar>
          <Box>
            {props.logo && (
              <Logo
                src={props.logo}
                alt={props.name}
                dataTestId="restaurant-logo"
                logoLinkPath={props.logoLinkPath}
              />
            )}
          </Box>
          <Box display="flex" justifyContent="flex-end">
            {props.children}
          </Box>
        </Toolbar>
      </GridContainer>
    </MuiAppBar>
  );
};

AppBar.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.string,
  name: PropTypes.string,
  logoLinkPath: PropTypes.string
};

export default React.memo(AppBar);
